import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../i18n';
import toast from 'react-hot-toast';
import { PremiumButton } from './ui/PremiumButton';

const MOCK_BALANCE = 1500;

export const CashbackTab: React.FC = () => {
  const { t } = useI18n();
  const transactions = [
    { id: 1, type: 'earn', description: t('activityHaircut'), amount: 250, date: '18.11.2025' },
    { id: 2, type: 'earn', description: t('activityStyling'), amount: 120, date: '15.11.2025' },
    { id: 3, type: 'earn', description: t('activityHaircutBeard'), amount: 300, date: '10.11.2025' },
    { id: 4, type: 'earn', description: t('activityShampoo'), amount: 90, date: '05.11.2025' },
    { id: 5, type: 'spend', description: t('activitySpend'), amount: -450, date: '01.11.2025' },
  ];
  const handleExchange = () => {
    toast('Cashback will be applied on your next appointment.', { icon: '\u2728' });
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6 pb-24">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-white mb-1">💎 {t('loyaltyClub')}</h2>
        <p className="text-white/60 text-sm">{t('cashbackSubtitle')}</p>
      </div>

      <motion.div 
        whileHover={{ scale: 1.02 }}
        className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-amber-300 via-yellow-500 to-amber-600 p-8 text-black shadow-xl shadow-amber-500/20"
      >
        <div className="absolute top-0 right-0 -mt-4 -mr-4 w-32 h-32 bg-white/20 rounded-full blur-2xl" />
        <div className="relative z-10">
          <p className="text-black/70 font-bold text-sm uppercase tracking-wider">{t('balance')}</p>
          <div className="flex items-baseline gap-2 mt-1">
            <span className="text-5xl font-black tracking-tight">{MOCK_BALANCE}</span>
            <span className="text-xl font-bold opacity-80">₽</span>
          </div>
          <div className="mt-6 flex items-center gap-2 bg-black/10 px-3 py-1.5 rounded-lg w-fit backdrop-blur-sm">
            <span className="text-xs font-bold">SHERIFF</span>
            <span className="text-xs opacity-70">• {t('cashbackBonus')}</span>
          </div>
        </div>
      </motion.div>

      <div className="grid grid-cols-3 gap-3 text-center">
        <div className="glass-card p-3 rounded-xl">
          <div className="text-[10px] font-bold text-white/70 uppercase mb-2">{t('haircuts')}</div>
          <div className="text-amber-400 font-bold">5%</div>
        </div>
        <div className="glass-card p-3 rounded-xl">
          <div className="text-[10px] font-bold text-white/70 uppercase mb-2">{t('products')}</div>
          <div className="text-amber-400 font-bold">3%</div>
        </div>
        <div className="glass-card p-3 rounded-xl">
          <div className="text-[10px] font-bold text-white/70 uppercase mb-2">{t('birthday')}</div>
          <div className="text-amber-400 font-bold">15%</div>
        </div>
      </div>

      <div className="glass-card rounded-3xl overflow-hidden">
        <div className="p-4 border-b border-white/5 flex justify-between items-center">
          <h3 className="font-bold text-white">{t('history')}</h3>
          <button className="text-xs text-amber-400 font-medium hover:underline">{t('all')}</button>
        </div>
        <div className="divide-y divide-white/5">
          {transactions.map((transaction) => (
            <div key={transaction.id} className="p-4 flex items-center justify-between hover:bg-white/5 transition-colors">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-lg ${transaction.type === 'earn' ? 'bg-green-500/20 text-green-400' : 'bg-white/10 text-white'}`}>
                  {transaction.type === 'earn' ? '📥' : '📤'}
                </div>
                <div>
                  <p className="font-bold text-white text-sm">{transaction.description}</p>
                  <p className="text-xs text-white/40">{transaction.date}</p>
                </div>
              </div>
              <span className={`font-bold ${transaction.type === 'earn' ? 'text-green-400' : 'text-white'}`}>
                {transaction.amount > 0 ? '+' : ''}{transaction.amount} ₽
              </span>
            </div>
          ))}
        </div>
      </div>

      <PremiumButton 
        onClick={handleExchange} 
        variant="primary" 
        fullWidth
        className="py-4 h-auto shadow-lg shadow-amber-500/20"
      >
        {t('spendPoints')}
      </PremiumButton>
    </motion.div>
  );
};

